import { useEffect, useState } from "react";
import { Music2, Camera, Sliders, Plane, Layers, Sparkles, ArrowUpRight } from "lucide-react";
import { api } from "@/lib/api";

const ICONS = { Music2, Camera, Sliders, Plane, Layers, Sparkles };

const TINTS = ["bg-warmwhite", "bg-taupe/15", "bg-olive/10", "bg-warmwhite", "bg-taupe/15", "bg-olive/10"];

export default function Services() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/services").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  return (
    <section id="services" className="py-24 md:py-36 bg-warmwhite border-t border-taupe/30" data-testid="services-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <div>
            <p className="text-[11px] uppercase tracking-widest-custom text-olive mb-6">02 — Services</p>
            <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight max-w-3xl" data-testid="services-title">
              Five disciplines, <span className="italic text-gold">one standard.</span>
            </h2>
          </div>
          <p className="text-charcoal/70 max-w-md text-base leading-relaxed">
            Each engagement is led personally — from creative direction to delivery. No handoffs to junior teams. No cut corners.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 auto-rows-fr gap-4">
          {items.map((s, i) => {
            const Icon = ICONS[s.icon] || Sparkles;
            const spanClass = s.span === 2 ? "md:col-span-2" : "";
            return (
              <a
                href="#contact"
                key={s.id}
                data-testid={`service-card-${s.id}`}
                className={`group relative ${TINTS[i % TINTS.length]} ${spanClass} border border-taupe/30 p-8 md:p-12 transition-all duration-500 hover:border-charcoal hover:-translate-y-1 hover:shadow-2xl shadow-charcoal/5`}
              >
                <div className="flex items-start justify-between">
                  <Icon className="w-8 h-8 text-charcoal" strokeWidth={1.2} />
                  <ArrowUpRight className="w-5 h-5 text-charcoal/50 transition-all duration-500 group-hover:text-gold group-hover:rotate-45" />
                </div>
                <h3 className="mt-12 font-serif text-2xl md:text-3xl font-medium leading-tight">{s.title}</h3>
                <p className="mt-4 text-sm md:text-[15px] text-charcoal/70 leading-relaxed">{s.description}</p>
                <p className="mt-8 text-[10px] uppercase tracking-widest-custom text-charcoal/45">0{i + 1} / 0{items.length}</p>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}
